const isMobileAccess = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('iphone')) {
    return true;
  } else if (userAgent.includes('android') && userAgent.includes('mobile')) {
    return true;
  }
  return false;
};

export const userAgentService = {
  isMobileAccess,
};

export default userAgentService;



// WEBPACK FOOTER //
// ./src/services/userAgent.js